// import './whyDidYouRender';
import React from 'react';
import ReactDOM from 'react-dom';
import DashApp from './dashApp';
import * as serviceWorker from './serviceWorker';

const PASSIVE_EVENTS = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel'];

if (process.env.NODE_ENV !== 'development')
    console.log = () => {};

const checkType = (type, options) => {
    if (!PASSIVE_EVENTS.includes(type))
        return null;

    const modOptions = {
        boolean: {
            capture: options,
            passive: false,
        },
        object: {
            ...options,
            passive: false,
        },
    };

    return modOptions[typeof options];
};

const addEventListener = document.addEventListener.bind();
document.addEventListener = (type, listener, options, wantsUntrusted) => (
    addEventListener(type, listener, checkType(type, options) || options, wantsUntrusted)
);

const removeEventListener = document.removeEventListener.bind();
document.removeEventListener = (type, listener, options) => (
    removeEventListener(type, listener, checkType(type, options) || options)
);

ReactDOM.render(<DashApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
